<template>
    <v-app class="app-custom">
        <v-main class="h-100">
            <router-view />

            <v-snackbar
                class="v-snackbar--font-weight-bold-custom"
                :model-value="toast.isShow"
                :timeout="toast.timeout"
                :color="toast.color"
                @update:modelValue="toastClose"
            >
                {{ toast.message }}
                <template v-slot:actions>
                    <v-btn
                        color="white"
                        variant="text"
                        size="small"
                        @click="toastClose"
                    >
                        Đóng
                    </v-btn>
                </template>
            </v-snackbar>

            <v-dialog
                :model-value="isLoadingShow"
                :persistent="true"
                width="auto"
            >
                <v-btn
                    loading
                    size="x-large"
                    class="pa-10"
                ></v-btn>
            </v-dialog>
        </v-main>
    </v-app>
</template>

<script>
export default {
    name: 'App',
    computed: {
        toast() {
            return this.$store.getters['toast/toast']
        },
        isLoadingShow() {
            return this.$store.state.loading.isShow
        },
    },
    methods: {
        toastClose() {
            this.$store.dispatch('toast/close')
        },
    },
}
</script>
